module.exports = __webpack_public_path__ + "static/img/71015A_1_C_20210426_LC.aa0f1ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/71015A_1_C_20210426_LC.png
// module id = ws7Y
// module chunks = 0